import { render, staticRenderFns } from "./eFooter.vue?vue&type=template&id=96acec9c&scoped=true&"
var script = {}
import style0 from "./eFooter.vue?vue&type=style&index=0&id=96acec9c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96acec9c",
  null
  
)

export default component.exports